import './Post-Top.svelte.css.proxy.js';
/* src/components/Post-Top.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_bidirectional_transition,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	query_selector_all,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import PostTagsProjects from "./Post-Tags-Projects.svelte.js";
import Title from "./Title.svelte.js";
import { fly } from "../_snowpack/pkg/svelte/transition.js";

function create_default_slot(ctx) {
	let t;

	return {
		c() {
			t = text(/*title*/ ctx[0]);
		},
		l(nodes) {
			t = claim_text(nodes, /*title*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*title*/ 1) set_data(t, /*title*/ ctx[0]);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let title_value;
	let t0;
	let div;
	let title_1;
	let t1;
	let posttagsprojects;
	let div_transition;
	let current;
	document.title = title_value = /*title*/ ctx[0];

	title_1 = new Title({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	posttagsprojects = new PostTagsProjects({
			props: {
				tags: /*tags*/ ctx[1],
				projects: /*projects*/ ctx[2]
			}
		});

	return {
		c() {
			t0 = space();
			div = element("div");
			create_component(title_1.$$.fragment);
			t1 = space();
			create_component(posttagsprojects.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-1258swp\"]", document.head);
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(title_1.$$.fragment, div_nodes);
			t1 = claim_space(div_nodes);
			claim_component(posttagsprojects.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "svelte-1bjk9zc");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, div, anchor);
			mount_component(title_1, div, null);
			append(div, t1);
			mount_component(posttagsprojects, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*title*/ 1) && title_value !== (title_value = /*title*/ ctx[0])) {
				document.title = title_value;
			}

			const title_1_changes = {};

			if (dirty & /*$$scope, title*/ 9) {
				title_1_changes.$$scope = { dirty, ctx };
			}

			title_1.$set(title_1_changes);
			const posttagsprojects_changes = {};
			if (dirty & /*tags*/ 2) posttagsprojects_changes.tags = /*tags*/ ctx[1];
			if (dirty & /*projects*/ 4) posttagsprojects_changes.projects = /*projects*/ ctx[2];
			posttagsprojects.$set(posttagsprojects_changes);
		},
		i(local) {
			if (current) return;
			transition_in(title_1.$$.fragment, local);
			transition_in(posttagsprojects.$$.fragment, local);

			add_render_callback(() => {
				if (!div_transition) div_transition = create_bidirectional_transition(div, fly, { x: -200, duration: 400 }, true);
				div_transition.run(1);
			});

			current = true;
		},
		o(local) {
			transition_out(title_1.$$.fragment, local);
			transition_out(posttagsprojects.$$.fragment, local);
			if (!div_transition) div_transition = create_bidirectional_transition(div, fly, { x: -200, duration: 400 }, false);
			div_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(div);
			destroy_component(title_1);
			destroy_component(posttagsprojects);
			if (detaching && div_transition) div_transition.end();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { title = "XX" } = $$props;
	let { tags } = $$props;
	let { projects } = $$props;

	$$self.$$set = $$props => {
		if ("title" in $$props) $$invalidate(0, title = $$props.title);
		if ("tags" in $$props) $$invalidate(1, tags = $$props.tags);
		if ("projects" in $$props) $$invalidate(2, projects = $$props.projects);
	};

	return [title, tags, projects];
}

class Post_Top extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { title: 0, tags: 1, projects: 2 });
	}
}

export default Post_Top;
//# sourceMappingURL=Post-Top.svelte.js.map
